import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogFooter } from "./EditPercentagesDialog";

export function DeleteConfirmModal({
    open,
    onClose,
    onConfirm,
    title = "Confirm deletion",
    description = "This action is permanent and cannot be undone.",
    busy = false,
    children,
}) {
    const [confirmText, setConfirmText] = useState("");

    const handleClose = () => {
        setConfirmText("");
        onClose();
    };

    const canConfirm = confirmText === "DELETE";

    const handleConfirm = async () => {
        if (!canConfirm || busy) return;
        await onConfirm();
        setConfirmText("");
    };

    if (!open) return null;

    return (
        <Dialog
            onClose={handleClose}
            title={title}
            subtitle={description}
            testid="delete-confirm-dialog"
            size="md"
        >
            <div className="space-y-4">
                {children}
                <p className="text-sm text-white/55">
                    Type <span className="font-mono text-rose-400 font-semibold">DELETE</span> to confirm this destructive action.
                </p>
                <input
                    type="text"
                    value={confirmText}
                    onChange={(e) => setConfirmText(e.target.value)}
                    placeholder="Type DELETE"
                    className="input-dark w-full rounded-md px-3 py-2 text-sm font-mono"
                    autoComplete="off"
                    data-testid="delete-confirm-input"
                />
            </div>
            <DialogFooter>
                <button onClick={handleClose} className="btn-ghost rounded-md px-4 py-2 text-sm" disabled={busy}>
                    Cancel
                </button>
                <button
                    onClick={handleConfirm}
                    disabled={!canConfirm || busy}
                    className="rounded-md px-4 py-2 text-sm font-medium inline-flex items-center gap-2 bg-rose-600 hover:bg-rose-500 disabled:opacity-40 disabled:cursor-not-allowed text-white transition-colors"
                    data-testid="delete-confirm-submit"
                >
                    {busy && <Loader2 className="h-4 w-4 animate-spin" />}
                    {busy ? "Deleting…" : "Delete permanently"}
                </button>
            </DialogFooter>
        </Dialog>
    );
}
